// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".usage-fees-only-payment-rate-table .table-name[data-v-ac922de6],.usage-fees-only-payment-rate-table .title[data-v-ac922de6]{font-size:18px;font-weight:700}.usage-fees-only-payment-rate-table .validation-label[data-v-ac922de6]{color:#d94a7d;font-size:10px;border:1px solid #d94a7d;padding:1px 4px 0 4px;margin:2px 6px 4px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
